import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Displays text.", -1)
const _hoisted_4 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.contentName), 1),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form_item, {
        prop: "text",
        label: "Text"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.content.text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content.text) = $event)),
            placeholder: "Text"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])
  ]))
}